export default __webpack_public_path__ + "static/bg-2c87d42cf9148b7b688467ca71931774.svg";